var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgLeftArrow = function SvgLeftArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11.539 20.181"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M3.479 10.093l7.637 7.631a1.436 1.436 0 010 2.037 1.454 1.454 0 01-2.043 0L.421 11.115a1.44 1.44 0 01-.042-1.989L9.067.42a1.442 1.442 0 012.043 2.037z"
  })));
};
export default SvgLeftArrow;